import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { meterFrameUnitTypePartial } from '@shared/partials/meterframe-unittype.partial';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';
import { systemServicesDetailsMasterdata } from '@shared/interfaces/nts/system-services-details.masterdata';

export const meterFrameColumns = [
  {
    title: 'connectionpoint.history.index',
    key: 'index'
  },
  {
    title: 'meterFrame.identification',
    key: 'identification'
  },
  {
    title: 'meterFrame.primaryMeterFrame',
    key: 'primaryMeterFrameIdentification'
  },
  meterFrameUnitTypePartial,
  {
    title: 'meterFrame.transformer',
    key: 'transformer'
  },
  {
    title: 'meterFrame.conversionFactors.A14',
    key: 'conversionFactorA14',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meterFrame.conversionFactors.A23',
    key: 'conversionFactorA23',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meterFrame.conversionFactors.R12',
    key: 'conversionFactorR12',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meterFrame.conversionFactors.R34',
    key: 'conversionFactorR34',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meterFrame.capacity',
    key: 'capacity'
  },
  ...systemServicesDetailsMasterdata,
  {
    title: 'meterFrame.Date',
    key: 'date',
    cellRenderer: DateCellComponent
  },
  {
    title: 'meterFrame.status',
    key: 'status',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      notspecified: {color: 'bg-yellow-500', label: 'status.unknown'},
      active: {color: 'bg-green-500', label: 'status.active'},
      inactive: {color: 'bg-red-500', label: 'status.inactive'},
    }
  },
  {
    title: 'meterFrame.networkPlacement',
    key: 'networkPlacement'
  },
  {
    title: 'meter.meterNumber',
    key: 'meterNumber'
  },
  {
    title: 'meter.conversionFactors.A14',
    key: 'meterConversionFactorA14',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meter.conversionFactors.A23',
    key: 'meterConversionFactorA23',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meter.conversionFactors.R12',
    key: 'meterConversionFactorR12',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meter.conversionFactors.R34',
    key: 'meterConversionFactorR34',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
    }
  },
  {
    title: 'meter.alternativeMeterNumber',
    key: 'alternateMeterNumber'
  },
  {
    title: 'meter.commissioningDate',
    key: 'meterCommissioningDate',
    cellRenderer: DateCellComponent
  },
  {
    title: 'meter.serialNumber',
    key: 'meterSerialNumber'
  },
  {
    title: 'meterFrame.status',
    key: 'meterStatus',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      notspecified: {color: 'bg-yellow-500', label: 'status.unknown'},
      active: {color: 'bg-green-500', label: 'status.active'},
      passive: {color: 'bg-yellow-500', label: 'status.passive'},
    }
  },
  {
    title: 'vendor.name',
    key: 'meterVendorName'
  },
  {
    title: 'model.name',
    key: 'meterModelName'
  },
  {
    title: 'model.productionYear',
    key: 'meterProductionYear'
  },
  {
    title: 'model.numberOfDigits',
    key: 'meterNumberOfDigits'
  },
  {
    title: 'model.readingType',
    key: 'meterReadingType',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meterReadingType.notSpecified',
      balanced: 'meterReadingType.balanced',
      none: 'meterReadingType.none',
      accumulated: 'meterreadingtype.accumulated'
    }
  },
  {
    title: 'meter.acquisitionDate',
    key: 'acquisitionDate',
    cellRenderer: DateCellComponent
  },
  {
    title: 'meter.accuracyClass',
    key: 'accuracyClass',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meter.accuracyClasses.notspecified',
      a: 'meter.accuracyClasses.a',
      b: 'meter.accuracyClasses.b',
      c: 'meter.accuracyClasses.c',
      zeropointtwos: 'meter.accuracyClasses.zeropointtwos',
      zeropointfive: 'meter.accuracyClasses.zeropointfive'
    }
  },
  {
    title: 'meter.measurementPrinciple',
    key: 'measurementPrinciple'
  },
  {
    title: 'meter.comment',
    key: 'comment'
  },
  {
    title: 'meter.ctTurnOverRatio',
    key: 'ctTurnOverRatioDisplayValue',
  },
  {
    title: 'meter.vtTurnOverRatio',
    key: 'vtTurnOverRatioDisplayValue'
  }
];
